
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62 75"><path fill="#7B42BC" fill-rule="evenodd" d="m21.2 16.55 19.1 11.03v22.06L21.2 38.61V16.55zm21.19 11.03v22.06L61.5 38.61V16.55L42.39 27.58zM0 4.24V26.3l19.1 11.03V15.27L0 4.24zm21.2 58.85 19.1 11.03V52.06L21.2 41.03v22.06z" clip-rule="evenodd"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    